import {
  hideIntercom,
  showNewMessage as intercomShowNewMessage,
  onHideIntercom,
  onShowIntercom,
  openIntercom,
} from '@/lib/Intercom';
import { atom, useAtom } from 'jotai';
import { useEffect } from 'react';

export const isIntercomOpenAtom = atom<boolean | undefined>(undefined);

export function useIntercom() {
  const [isIntercomOpen, setIsIntercomOpen] = useAtom(isIntercomOpenAtom);

  useEffect(() => {
    onHideIntercom(() => {
      setIsIntercomOpen(false);
    });

    onShowIntercom(() => {
      setIsIntercomOpen(true);
    });
  }, [setIsIntercomOpen]);

  const showMessageModal = () => {
    openIntercom();
  };

  const hideMessageModal = () => {
    hideIntercom();
  };

  /**
   * Opens Intercom with a pre-filled message for the user to review and send
   */
  const showNewMessage = (message: string) => {
    intercomShowNewMessage(message);
  };

  return {
    isIntercomOpen,
    showMessageModal,
    hideMessageModal,
    showNewMessage,
  };
}
